<template>
	<div class="table-filters">
		<div class="table-filters__row">
			<div class="table-filters__search">
				<FontAwesomeIcon
					class="table-filters__search-icon"
					icon="fal fa-magnifying-glass" />
				<InputText
					class="table-filters__search-input"
					:model-value="filters.search"
					:placeholder
					@update:model-value="debouncedUpdateSearch" />
				<button
					v-if="filters.search"
					class="table-filters__clear"
					type="button"
					@click="clearSearch">
					<FontAwesomeIcon icon="fal fa-xmark" />
				</button>
			</div>
			<FilterMenu
				v-if="controls.items.length > 0"
				:controls
				:filters
				@updated="emit('updated')" />
		</div>
		<div class="table-filters__chips">
			<ActiveFilters
				:controls
				:filters
				@remove="removeFilter"
				@updated="emit('updated')" />
			<span class="table-filters__gap" />
			<FilterModifiers
				:filters
				@updated="emit('updated')" />
		</div>
	</div>
</template>

<script setup lang="ts">
import InputText from 'primevue/inputtext'
import { Filters } from '@/helpers/filters/Filters'
import { Filter } from '@/helpers/filters/Filter'
import type { FilterControls } from '@/helpers/filters/FilterControls'
import FilterMenu from './FilterMenu.vue'
import ActiveFilters from './ActiveFilters.vue'
import FilterModifiers from './FilterModifiers.vue'
import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue'

const props = defineProps<{
	controls: FilterControls<any>
	filters: Filters<any>
	placeholder: string
}>()

const emit = defineEmits<{
	(e: 'updated'): void
}>()

let searchTimer: any = null

function debouncedUpdateSearch(value: string | undefined) {
	if (searchTimer) clearTimeout(searchTimer)
	searchTimer = setTimeout(() => {
		props.filters.search = value ?? ''
		emit('updated')
	}, 300)
}

function removeFilter(f: Filter<any>) {
	props.filters.list.delete(f)
}

function clearSearch() {
	props.filters.search = ''
	emit('updated')
}
</script>

<style scoped lang="scss">
.table-filters {
	display: flex;
	flex-direction: column;
	gap: 8px;

	.table-filters__row {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.table-filters__chips {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.table-filters__gap {
		flex: 1;
	}

	.table-filters__search {
		flex: 1;
		position: relative;

		.table-filters__search-icon :deep(svg) {
			position: absolute;
			left: 12px;
			top: 50%;
			transform: translateY(-50%);
			color: var(--p-text-secondary);
		}

		.table-filters__search-input {
			width: 100%;
			padding-left: 38px;
		}

		.table-filters__clear {
			position: absolute;
			right: 8px;
			top: 50%;
			transform: translateY(-50%);
			background: transparent;
			border: none;
			color: var(--p-text-secondary);
			cursor: pointer;
			padding: 4px;
		}
	}
}
</style>
